module.exports = __webpack_public_path__ + "static/media/S (54).82a8cf40.jpg";